import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { TARGET_NETWORKS, wagmiConfig } from 'configurations/wagmi';
import { WagmiProvider } from 'wagmi';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MainLayout } from 'screens/MainLayout';
import { LandingPageContent } from 'screens/Landing/LandingPageContent';
import { Dashboard } from 'screens/Dashboard/Dashboard';
import { Referrals } from 'screens/Referals/Referrals';
import ReferralSaver from 'screens/Landing/components/PaymentDialogs/ReferralSaver';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { initializeGlobalErrorHandlers } from 'utils/globalErrorHandler';
import { WalletConnectErrorBoundary } from 'components/WalletConnectErrorBoundary';

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    // Initialize global error handlers for WalletConnect session errors
    initializeGlobalErrorHandlers();

    const body = document.body;

    const preventScroll = () => {
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.width = '100%';
    };

    const allowScroll = () => {
      body.style.overflow = '';
      body.style.position = '';
      body.style.width = '';
    };

    const observer = new MutationObserver(() => {
      if (body.hasAttribute('data-scroll-locked')) {
        preventScroll();
      } else {
        allowScroll();
      }
    });

    observer.observe(body, {
      attributes: true,
      attributeFilter: ['data-scroll-locked'],
    });

    return () => {
      observer.disconnect();
      allowScroll();
    };
  }, []);

  return (
    <WalletConnectErrorBoundary>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider
            modalSize="compact"
            initialChain={TARGET_NETWORKS.id}
            theme={darkTheme({
              accentColor: '#CFB2FF',
              accentColorForeground: '#111111',
              borderRadius: 'large',
              overlayBlur: 'small',
              fontStack: 'system',
            })}
          >
            <ToastContainer />
            <Routes>
              <Route path="/referral/:code" element={<ReferralSaver />} />
              <Route path="/" element={<MainLayout />}>
                <Route index element={<LandingPageContent />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="referrals" element={<Referrals />} />
              </Route>
            </Routes>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </WalletConnectErrorBoundary>
  );
}

export default App;
